import { useEffect, useLayoutEffect } from "react";

export default function usePreserveScroll(ref, key) {
  // Restore on mount
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const saved = sessionStorage.getItem(key);
    if (saved) {
      requestAnimationFrame(() => {
        el.scrollTop = parseInt(saved, 10) || 0;
      });
    }
  }, [ref, key]);

  // Save on scroll + unmount
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let raf = null;

    const handleScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        sessionStorage.setItem(key, el.scrollTop);
        raf = null;
      });
    };

    el.addEventListener("scroll", handleScroll);

    return () => {
      el.removeEventListener("scroll", handleScroll);
      if (raf) cancelAnimationFrame(raf);
      sessionStorage.setItem(key, el.scrollTop);
    };
  }, [ref, key]);
}
